/**
 * Formatting helpers. Prices are in Sri Lankan rupees (LKR).
 */
export const CURRENCY_LABEL = 'Rs.';

export function formatPrice(value: string | number | null | undefined, withSymbol = true): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = typeof value === 'string' ? parseFloat(value) : value;
  if (Number.isNaN(n)) return '—';
  const formatted = n.toLocaleString('en-LK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return withSymbol ? `${CURRENCY_LABEL} ${formatted}` : formatted;
}

export function formatCompactPrice(value: number): string {
  if (value >= 1_000_000) return `${CURRENCY_LABEL} ${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${CURRENCY_LABEL} ${(value / 1_000).toFixed(1)}k`;
  return formatPrice(value);
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function formatShortDate(value: string | null | undefined): string {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
}

export function formatCountdown(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${r.toString().padStart(2, '0')}`;
}

export type StockLevel = 'in' | 'low' | 'out';

export function stockLevel(available: number): StockLevel {
  if (available <= 0) return 'out';
  if (available <= 2) return 'low';
  return 'in';
}
